/**
 * Edit Controller
 */
/*
  globals moment
*/
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.controller('InsertionOrderEditController', [
    '$scope',
    '$window',
    '$timeout',
    'insertionOrderApi',
    'advertiserApi',
    'campaignApi',
    'optionsApi',
    function($scope, $window, $timeout, insertionOrderApi, advertiserApi, campaignApi, optionsApi) {
      $scope.now = moment
        .utc()
        .seconds(0)
        .milliseconds(0)
        .valueOf();

      $scope.startDateTitle = $scope.endDateTitle = '';
      $scope.startTimeTitle = $scope.endTimeTitle = '';

        // init values
      $scope.io = {
        _advertiserId: false,
        _id: null,
        timezone: window.tz ? window.tz : 'Europe/Berlin',
      };

      var precisionRound = function (number, precision) {
        var factor = Math.pow(10, precision);

        return Math.round(number * factor) / factor;
      };

        $scope.getMinStartDate = function() {
            return null;
        };

        $scope.getMaxStartDate = function() {
            return null;
        };

        $scope.getMinEndDate = function() {
            var start = $scope.io.start ? $scope.io.start : 0;
            return start;
        };

        // get iab categories
        optionsApi.getIab(true, true, true).then(
            function(iab) {
                $scope.iab = iab;
            },
            function() {
                console.error('could not load iab categories');
            }
        );


      $scope.log = {
        count: 0,
        data: [],
      };


        $scope.quickComplete = function(name) {
            switch (name){
                case 'start':
                    $scope.io.start = $scope.now;
                    break;
                case 'end':
                    $scope.io.end = moment($scope.now)
                        .endOf("day")
                        .valueOf();
                    break;
                case 'adomain':
                    if ($scope.io._advertiserId)
                        $scope.io.adomain = $scope.advertisers_full[$scope.io._advertiserId].url;
                    break;
                case 'logo':
                    if ($scope.io._advertiserId)
                        $scope.io.logo = $scope.advertisers_full[$scope.io._advertiserId].logo;
                    break;
                case 'iab_cat':
                    if ($scope.io._advertiserId)
                        $scope.io.iab_category = $scope.advertisers_full[$scope.io._advertiserId].iab_category;
                    break;
            }


        };

        /**
         * Fetch list data from server
         */
        $scope.fetch = function() {
            // load io from server
            if (window.ioId) {
                insertionOrderApi.read(window.ioId).then(
                    function (data) {
                        $scope.io = data.io;
                        $scope.log = data.log;

                        console.log("fetch IO done.");
                        console.log($scope.io);

                        insertionOrderApi.getCampaigns($scope.io._id).then(
                            function (res) {
                                $scope.campaigns = res.data;
                                console.log("fetch getCampaigns done.");
                                console.log($scope.campaigns);

                                var impsInAllCampaigns = $scope.campaigns.length > 0; // true by default if there is at least one campaign assigned
                                $scope.campaigns.forEach(function (campaign) {
                                    campaign.imps_actual = campaign.n_impression;
                                    if (campaign.imps_actual === 0) {
                                        impsInAllCampaigns = false;
                                    }
                                });
                                if (impsInAllCampaigns) {
                                    $scope.startDisabled = true;
                                    $scope.startDateTitle = 'You cannot change the start date, because at least 1 impression has been delivered in all assigned campaigns.';
                                    $scope.startTimeTitle = 'You cannot change the start time, because at least 1 impression has been delivered in all assigned campaigns.';
                                }
                            },
                            function () {
                                console.error('could not load campaigns');
                            });
                    },
                    function () {
                        console.error('could not load io');
                    }
                );
            } else if (!window.ioId && window.advertiserId) {
                // for new ios inherit advertiser from client selection if set
                $scope.io._advertiserId = window.advertiserId;
            }
        }


      // get advertisers
      advertiserApi
        .getList(
          { field: 'name', order: 'asc' },
          '',
          { number: 0, size: -1 }
        )
        .then(
          function(advertisers) {
            $scope.advertisers = [];
            $scope.advertisers_full = [];

            advertisers.data.forEach(function(advertiser) {
              $scope.advertisers.push({
                name: advertiser.name,
                value: advertiser._id,
              });
              $scope.advertisers_full[advertiser._id] = advertiser;
            });
          },
          function() {
            console.error('could not load advertisers');
          }
        );

      // try saving and process server side validation errors
      $scope.submitForm = function(isModalWindowOpened) {
        insertionOrderApi.save($scope.io).then(
          function() {
            if (isModalWindowOpened) {
              $('#submit-modal').modal('hide');
              $('body').removeClass('modal-open');
              $('.modal-backdrop').remove();
            }

            $window.location.href = '/#!/demandmgr/insertion-order';
          },
          function(data) {
              defaultSaveErrorHandler($scope.ioForm, data);
          }
        );
      };

      /**
       * display a warning if IO budget exceeds 1 Mio
       */
      $scope.promptSubmit = function() {
         !$scope.io.adomain && $scope.quickComplete('adomain');
         !$scope.io.logo && $scope.quickComplete('logo');
         !$scope.io.iab_category && $scope.quickComplete('iab_cat');

          if (!$scope.ioForm.$valid)
              return;

          $scope.submitForm(false);
      };

      /**
       * check if IO name unique per advertiser
       * @return {boolean}
       */
      $scope.isNameUnique = function() {
        if ($scope.ioForm && $scope.ioForm.hasOwnProperty('name')) {
          return !$scope.ioForm['name'].$error.unique;
        }

        return true;
      };
      //$timeout( function(){$scope.fetch();}, 20);
       $scope.fetch();
    },
  ]);
})(window.angular);
